import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styles from "./Perfil.module.css"; // Asegúrate de que este archivo contenga los estilos

import fotoAriana from "./Fotos/Ariana.webp";
import fotoDash from "./Fotos/Dash.webp";
import fotoEli from "./Fotos/Eli.webp";
import fotoEmilio from "./Fotos/Emilio.webp";
import fotoIgnacio from "./Fotos/Igna.webp";
import fotoKevin from "./Fotos/Kevin.webp";
import fotoLuisa from "./Fotos/Luisa.webp";
import fotoMartin from "./Fotos/Martin.webp";
import fotoSebas from "./Fotos/Sebas.webp";
import fotoIsaac from "./Fotos/Isaac.webp";
import fotoDaniela from "./Fotos/Daniela.webp";
import fotoStephano from "./Fotos/Stephano.webp";
import fotoJuan from "./Fotos/Juan.webp";
import fotoJuanse from "./Fotos/Juanse.webp";
import fotoEsteban from "./Fotos/Esteban.webp";

// Diccionario con la información de los perfiles
const perfiles = {
  luisa: {
    nombre: "Luisa Guerrero", 
    equipo: "Desarrolladora técnica",
    foto: fotoLuisa,
    linkedin: "http://www.linkedin.com/in/luisa-maria-guerrero-15a383270",
    whatsapp: "https://wa.link/0vu20p",
    email: "luisa.guerrero@relatividadia.com"
  },
  ariana: {
    nombre: "Ariana Cabrera",
    equipo: "Coordinadora de desarrollo creativo",
    foto: fotoAriana,
    linkedin: "https://linkedin.com/in/ariana-cabrera-vera-8a1473234",
    whatsapp: "https://wa.link/2ykmn2",
    email: "ariana.cabrera@relatividadia.com"
  },
  sebastian: {
    nombre: "Sebastián López",
    equipo: "Desarrollador de diseño creativo",
    foto: fotoSebas,
    linkedin: "https://www.linkedin.com/in/sebasti%C3%A1n-l%C3%B3pez-1a86a325a/",
    whatsapp: "https://wa.link/layd0l",
    email: "sebastian.lopez@relatividadia.com"
  },
  dash: {
    nombre: "David Escobar",
    equipo: "Coordinador general de desarrollo",
    foto: fotoDash,
    linkedin: "https://www.linkedin.com/in/david-escobar-3297a1307/",
    whatsapp: "https://wa.link/zymeh4",
    email: "david.escobar@relatividadia.com"
  },
  eli: {
    nombre: "Elisa Chamorro",
    equipo: "CMO",
    foto: fotoEli,
    linkedin: "https://www.linkedin.com/in/lorin-elisa-chamorro-jaramillo/",
    whatsapp: "https://wa.link/wxt2kc",
    email: "elisa.chamorro@relatividadia.com"
  },
  emilio: {
    nombre: "Emilio Rosado",
    equipo: "CEO",
    foto: fotoEmilio,
    linkedin: "https://www.linkedin.com/in/emilio-rosado/",
    whatsapp: "https://wa.link/0jmf44",
    email: "emilio@relatividadia.com"
 },
  ignacio: {
    nombre: "Ignacio Zambrano",
    equipo: "Desarrollador técnico",
    foto: fotoIgnacio,
    linkedin: "http://www.linkedin.com/in/ignacio-zambrano-03ba05304",
    whatsapp: "https://wa.link/b16260",
    email: "ignacio.zambrano@relatividadia.com"
  },
  kevin: {
    nombre: "Kevin Rojas",
    equipo: "CTO",
    foto: fotoKevin,
    linkedin: "https://www.linkedin.com/in/kevin-rojas-sati%C3%A1n-6895ab14b/",
    whatsapp: "https://wa.link/234cf4",
    email: "kevin@relatividadia.com"
  },
  martin: {
    nombre: "Martin Baca",
    equipo: "Coordinador de desarrollo técnico",
    foto: fotoMartin,
    linkedin: "http://www.linkedin.com/in/martín-baca-899102218",
    whatsapp: "https://wa.link/lsbei4",
    email: "martin.baca@relatividadia.com"
  },
  isaac: {
    nombre: "Isaac Porras",
    equipo: "Desarrollador de diseño creativo",
    foto: fotoIsaac,
    linkedin: "https://www.linkedin.com/in/isaac-porras-b24619254",
    whatsapp: "https://wa.link/dubls5",
    email: "isaac.porras@relatividadia.com"
  },
  daniela: {
    nombre: "Daniela Tarapues",
    equipo: "Desarrolladora de diseño creativo",
    foto: fotoDaniela,
    linkedin: "https://www.linkedin.com/in/daniela-tarapues232004/",
    whatsapp: "https://wa.link/gpy4ea",
    email: "daniela.tarapues@relatividadia.com"
  },
  stephano: {
    nombre: "Stephano Zapata",
    equipo: "Desarrollador técnico y de diseño creativo",
    foto: fotoStephano,
    linkedin: "https://www.linkedin.com/in/stephano-zapata-a7277429b/",
    whatsapp: "https://wa.link/xmgsnm",
    email: "stephano.zapata@relatividadia.com"
  },
  juan: {
    nombre: "Juan Morales",
    equipo: "Desarrollador de software",
    foto: fotoJuan,
    linkedin: "http://www.linkedin.com/in/juan-morales-24653b328",
    whatsapp: "https://wa.link/hmaav0",
    email: "juan.morales@relatividadia.com"
  },
  juanse: {
    nombre: "Juan Sebastián Andrade",
    equipo: "Desarrollador de software",
    foto: fotoJuanse,
    linkedin: "https://www.linkedin.com/in/juan-andrade-74496b303/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    whatsapp: "https://wa.link/9r08uc",
    email: "juan.andrade@relatividadia.com"
  },
  esteban: {
    nombre: "Esteban Lopez",
    equipo: "Desarrollador de software",
    foto: fotoEsteban,
    linkedin: "https://www.linkedin.com/in/esteban-andr%C3%A9s-l%C3%B3pez-ocampo-704918228?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    whatsapp: "https://wa.link/rkc4d1",
    email: "esteban.lopez@relatividadia.com"
  }
  
};

const Perfil = () => {
    const { "perfil-nombre": perfilNombre } = useParams();
    const [perfil, setPerfil] = useState(null);
  
    useEffect(() => {

      const nombreClave = perfilNombre.replace('perfil-', '').toLowerCase();

      const perfilData = perfiles[nombreClave];
      if (perfilData) {
        setPerfil(perfilData);
      } else {
        // Manejar el caso de perfil no encontrado
        console.error('Perfil no encontrado');
      }
    }, [perfilNombre]);
  
    if (!perfil) {
      return <div>Cargando perfil...</div>;
    }
  
    return (
      <div className={styles.perfilContainer}>
        <img src={perfil.foto} alt="Profile" className={styles.profileImage} />
        <h1 className={styles.name}>{perfil.nombre}</h1>
        <h2 className={styles.title}>{perfil.equipo}</h2>
        <div className={styles.buttonContainer}>
          <a href={perfil.linkedin} target="_blank" rel="noopener noreferrer">
            <button className={styles.button}>LinkedIn</button>
          </a>
          <a href={perfil.whatsapp} target="_blank" rel="noopener noreferrer">
            <button className={styles.button}>Whatsapp</button>
          </a>
        </div>
        <p className={styles.emailPrompt}>Envíame un correo:</p>
        <p className={styles.email}>{perfil.email}</p>
      </div>
    );
  };
  
  export default Perfil;
